import React, { useContext, useEffect, useState } from 'react'
import CustomImage from '../../components/customImage/customImage'
// import Filter from './filter'
import dropDownArror from '../../assets/dropdown-svgrepo-com-1@3x.png'
import shoppingCart from '../../assets/cart-svgrepo-com@3x.png'
import handBag from '../../assets/handbag@3x.png'
// import transactionIcon from '../../assets/transaction-svgrepo-com@3x.png'
import cartFavoriteIcon from '../../assets/shopping-cart-favorite-02@3x.png'
import deleteIcon from '../../assets/delete-svgrepo-com-2@3x.png'
import { WISHLIST_URL } from '../../utils/apiUrls'
import useAxios from 'axios-hooks'
import { AppContext } from '../../context/app'
import { getProductImage } from '../../utils/helper'
import useTemplateHook from '../../components/template/templateHook'
import getSymbolFromCurrency from 'currency-symbol-map'
import { ContentContext } from '../../context/content'
import { useNavigate } from 'react-router'

const WishList = () => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [dataList, setDataList] = useState([])
  const { setLoader } = useContext(AppContext)
  const { getTemplateImage } = useTemplateHook()
  const { addRemoveWishList, isRequestDone } = useContext(ContentContext)

  const [{ data: eCommWishData, loading: eCommWishLoading }, getECommWishlist] = useAxios(
    {
      url: WISHLIST_URL,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    if (eCommWishData && eCommWishData.success) {
      setDataList(eCommWishData.data)
    }
  }, [eCommWishData])

  useEffect(() => {
    if (isRequestDone) {
      getECommWishlist()
    }
  }, [isRequestDone])

  useEffect(() => {
    getECommWishlist()
  }, [])

  useEffect(() => {
    setLoader(eCommWishLoading)
  }, [eCommWishLoading])

  return (
    <div className="w-full mt-2 xl:mt-4">
      <div className="flex justify-center px-3 md:px-6 items-center">
        <div className="w-full" style={{ maxWidth: '890px' }}>
          {/* Header */}
          <div className="flex justify-between items-center mb-6 relative">
            <div className="flex items-center gap-2" onClick={() => setOpen(!open)}>
              <p className="text-white font-semibold text-sm md:text-lg lg:text-xl">My Wishlist</p>
              <CustomImage
                imageUrl={dropDownArror}
                imgAlt={'dropDownArror'}
                imgClass={`w-5 h-5 object-contain ml-auto transform transition-transform lg:hidden ${
                  open ? 'rotate-180' : ''
                }`}
              />
            </div>
            <div className="flex items-center">
              {/* Desktop */}
              <div className="hidden lg:flex gap-5">
                <div
                  className="rounded px-5 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                  style={{
                    color: '#e3e2e2',
                    border: 'solid 1px #f60',
                  }}
                  onClick={() => navigate('/cart-details')}
                >
                  <CustomImage imageUrl={shoppingCart} imgAlt="cart" imgClass="w-4 h-4" />
                  <span>My Cart</span>
                </div>
                {/* <div
                  className="rounded px-4 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                  style={{
                    color: '#e3e2e2',
                    border: 'solid 1px #f60',
                  }}
                >
                  <CustomImage imageUrl={transactionIcon} imgAlt="bag" imgClass="w-3 h-3" />
                  <span>All Transactions </span>
                </div> */}
                <div
                  className="rounded px-4 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                  style={{
                    color: '#e3e2e2',
                    backgroundImage: 'linear-gradient(95deg, #f60 7%, #ff4e00 97%)',
                  }}
                  onClick={() => navigate('/store')}
                >
                  <CustomImage imageUrl={handBag} imgAlt="bag" imgClass="w-3 h-3" />
                  <span>Keep Shopping </span>
                </div>
                {/* <Filter
                  sections={[
                    {
                      label: 'View',
                      name: 'view',
                      options: ['Show All', 'In Stock only', 'Out of Stock only'],
                    },
                  ]}
                  onApply={(filters) => console.log(filters)}
                /> */}
              </div>

              {/* Mobile */}
              <div className="lg:hidden">
                {/* <Filter
                  sections={[
                    {
                      label: 'View',
                      name: 'view',
                      options: ['Show All', 'In Stock only', 'Out of Stock only'],
                    },
                  ]}
                  onApply={(filters) => console.log(filters)}
                /> */}
              </div>
            </div>

            {/* Mobile dropdown menu */}
            {open && (
              <div
                className="absolute top-full left-0 mt-2 w-full rounded-lg shadow-lg z-50 lg:hidden"
                style={{
                  backgroundColor: '#1d2a39',
                }}
              >
                <div className="flex flex-col gap-3 items-center mb-4 mt-3">
                  <div className="w-48">
                    <div
                      className="rounded px-5 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                      style={{
                        color: '#e3e2e2',
                        border: 'solid 1px #f60',
                      }}
                      onClick={() => navigate('/cart-details')}
                    >
                      <CustomImage imageUrl={shoppingCart} imgAlt="cart" imgClass="w-4 h-4" />
                      <span>My Cart</span>
                    </div>
                  </div>
                  {/* <div className="w-48">
                    <div
                      className="rounded px-4 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                      style={{
                        color: '#e3e2e2',
                        border: 'solid 1px #f60',
                      }}
                    >
                      <CustomImage imageUrl={transactionIcon} imgAlt="bag" imgClass="w-3 h-3" />
                      <span>All Transactions </span>
                    </div>
                  </div> */}
                  <div className="w-48">
                    <div
                      className="rounded px-4 py-2 text-sm flex items-center justify-center gap-2 cursor-pointer"
                      style={{
                        color: '#e3e2e2',
                        backgroundImage: 'linear-gradient(95deg, #f60 7%, #ff4e00 97%)',
                      }}
                      onClick={() => navigate('/store')}
                    >
                      <CustomImage imageUrl={handBag} imgAlt="bag" imgClass="w-3 h-3" />
                      <span>Keep Shopping </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Wishlist Items or Empty State */}
          {dataList && dataList.length > 0 ? (
            dataList.map((item, index) => (
              <div
                key={index}
                className="rounded-lg p-2 md:p-5 mb-3"
                style={{
                  backgroundColor: '#1d2a39',
                  width: '100%',
                  maxWidth: '890px',
                }}
              >
                <div className="flex items-start gap-4">
                  <div
                    className="text-white flex items-center justify-center text-xs rounded-md"
                    style={{ width: '24px', backgroundColor: '#333c47', height: '24px' }}
                  >
                    {index + 1}
                  </div>

                  <div className="bg-white rounded-lg flex items-center justify-center lg:h-40 h-24 flex-shrink-0 relative">
                    <CustomImage
                      imageUrl={getTemplateImage(getProductImage(item.img_s3_keys))}
                      imgAlt={item.name}
                      imgClass="w-full h-full object-cover"
                    />
                  </div>

                  <div className="flex-1">
                    <div className="flex flex-col md:flex-row md:justify-between h-full">
                      {/* Left side content */}
                      <div className="w-[230px] md:w-[350px] lg:w-[450px]">
                        <p className="text-white font-semibold text-xs lg:text-base mb-3 line-clamp-2">
                          {item.title}
                        </p>
                        <p className="text-xs mb-2 mt-2 md:mt-12" style={{ color: '#979797' }}>
                          Item added on 8 Sept 2025
                        </p>
                        <p
                          className="text-xs lg:text-sm mb-4 font-semibold"
                          style={{ color: item.in_stock ? '#52c90d' : '#fb2525' }}
                        >
                          {item.in_stock ? 'In Stock' : 'Out of Stock'}
                        </p>

                        {/* Price */}
                        <div className="flex items-center flex-wrap">
                          <span className="text-xs" style={{ color: '#979797' }}>
                            Price:
                          </span>
                          <span className="text-white text-base lg:text-2xl font-semibold ml-2">
                            {item.discount.enabled
                              ? parseFloat(
                                  item.price - (item.price * item.discount.discount_value) / 100,
                                ).toFixed(2)
                              : parseFloat(item.price).toFixed(2)}
                          </span>
                          <span className="text-white text-xs lg:text-base mt-1 ml-2 uppercase">
                            {getSymbolFromCurrency(item.currency || 'USD')}
                          </span>
                          {item.discount.enabled && (
                            <span
                              className="line-through md:mt-2 md:ml-3 mt-2 text-xs lg:text-base"
                              style={{ color: '#808080' }}
                            >
                              {item.price} {getSymbolFromCurrency(item.currency || 'USD')}
                            </span>
                          )}
                          {item.discount.enabled && (
                            <span className="bg-[#ff6600] mt-2 text-white px-3 ml-3 py-1 rounded-md text-xs lg:text-base font-semibold">
                              {item.discount.discount_value} %
                            </span>
                          )}
                        </div>
                      </div>

                      {/* Desktop buttons */}
                      <div className="hidden md:flex flex-col gap-2 justify-end">
                        <button
                          className="flex items-center justify-center gap-2 px-3 py-1 text-sm border rounded whitespace-nowrap"
                          style={{ color: '#e3e2e2', border: 'solid 1px #f60' }}
                          onClick={() => addRemoveWishList(item._id)}
                        >
                          <CustomImage imageUrl={deleteIcon} imgAlt="delete" imgClass="w-3 h-3" />
                          Remove from List
                        </button>
                        <button
                          className="flex items-center justify-center gap-2 px-2 py-1 text-sm rounded"
                          style={{
                            color: '#e3e2e2',
                            backgroundImage: 'linear-gradient(95deg, #f60 7%, #ff4e00 97%)',
                            opacity: !item.in_stock ? '0.5' : '1',
                          }}
                          onClick={() => navigate(`/product/${item._id}`)}
                          disabled={!item.in_stock}
                        >
                          <CustomImage
                            imageUrl={cartFavoriteIcon}
                            imgAlt="cartFavorite"
                            imgClass="w-4 h-4"
                          />
                          Add to Cart
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Mobile buttons */}
                <div className="md:hidden flex gap-3 mt-3">
                  <button
                    className="flex-1 flex items-center justify-center gap-1 px-2 py-1 text-[10px] border rounded"
                    style={{ color: '#e3e2e2', border: 'solid 1px #f60' }}
                    onClick={() => addRemoveWishList(item._id)}
                  >
                    <CustomImage imageUrl={deleteIcon} imgAlt="delete" imgClass="w-3 h-3" />
                    Remove
                  </button>
                  <button
                    className="flex-1 flex items-center justify-center gap-1 px-2 py-1 text-[10px] rounded"
                    style={{
                      color: '#e3e2e2',
                      backgroundImage: 'linear-gradient(95deg, #f60 7%, #ff4e00 97%)',
                      opacity: !item.in_stock ? '0.5' : '1',
                    }}
                    onClick={() => navigate(`/product/${item._id}`)}
                    disabled={!item.in_stock}
                  >
                    <CustomImage
                      imageUrl={cartFavoriteIcon}
                      imgAlt="cartFavorite"
                      imgClass="w-3 h-3"
                    />
                    Add
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div
              className="rounded-lg p-8 text-center"
              style={{
                backgroundColor: '#1d2a39',
                width: '100%',
              }}
            >
              <p className="text-white text-lg mb-4">Your wishlist is empty</p>
              <p className="text-gray-400 text-sm mb-6">
                Start adding items to your wishlist to see them here
              </p>
              <button
                className="px-6 py-3 rounded-lg text-sm font-medium"
                style={{
                  color: '#e3e2e2',
                  backgroundImage: 'linear-gradient(95deg, #f60 7%, #ff4e00 97%)',
                }}
                onClick={() => navigate('/store')}
              >
                Browse Products
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default WishList
